import { TriggerEvent } from '../../utils';

export enum CartesianSequenceNodeMessageType {
  SEQUENCE = 0,
}

export const truncatePosition = (
  sequence: Float32Array[][],
  position: [number, number, number],
): [number, number, number] => {
  const x = sequence.length === 0 ? 0 : position[0] % sequence.length;
  const square = sequence[x] ?? [];
  const y = square.length === 0 ? 0 : position[1] % square.length;
  const column = square[y] ?? [];
  const z = column.length === 0 ? 0 : position[2] % column.length;
  return [x, y, z];
};

export class CartesianSequenceNode extends AudioWorkletNode {
  readonly xClock: AudioParam;
  readonly yClock: AudioParam;
  readonly zClock: AudioParam;
  readonly reset: AudioParam;
  private _sequence: Float32Array[][];
  private _position: [number, number, number] = [0, 0, 0];

  constructor(
    context: BaseAudioContext,
    {
      sequence = [],
      xClock = 0,
      yClock = 0,
      zClock = 0,
      reset = 0,
    }: {
      sequence?: Float32Array[][];
      xClock?: number;
      yClock?: number;
      zClock?: number;
      reset?: number;
    },
  ) {
    super(context, 'CartesianSequenceProcessor', {
      numberOfInputs: 0,
      numberOfOutputs: 1,
      outputChannelCount: [1],
      channelCount: 1,
      channelCountMode: 'explicit',
      channelInterpretation: 'discrete',
      processorOptions: { sequence },
      parameterData: { xClock, yClock, zClock, reset },
    });
    this.port.onmessage = ({ data }) => {
      this._position = data;
      this.dispatchEvent(new TriggerEvent());
    };

    this._sequence = sequence;

    // @ts-ignore
    this.xClock = this.parameters.get('xClock');
    // @ts-ignore
    this.yClock = this.parameters.get('yClock');
    // @ts-ignore
    this.zClock = this.parameters.get('zClock');
    // @ts-ignore
    this.reset = this.parameters.get('reset');
  }

  get position(): [number, number, number] {
    return this._position;
  }

  get sequence(): Float32Array[][] {
    return this._sequence;
  }
  set sequence(sequence: Float32Array[][]) {
    this._sequence = sequence;
    this._position = truncatePosition(sequence, this._position);
    this.port.postMessage([
      CartesianSequenceNodeMessageType.SEQUENCE,
      sequence,
    ]);
  }
}
